/* ============================================================
   KISEKI NATURAL HOLISTICS — MOBILE ENHANCEMENTS v1.0
   Sticky ATC bar · Description read-more · Trust note
   ============================================================ */
(function () {
  'use strict';
  var MOBILE = function () { return window.innerWidth <= 749; };

  function initStickyATC() {
    if (!MOBILE()) return;
    var mainATC = document.querySelector('.product-form__submit');
    var priceEl = document.querySelector('.product__price .price-item--regular, .product__price .price-item');
    var titleEl = document.querySelector('h1.product__title');
    if (!mainATC) return;
    var bar = document.createElement('div');
    bar.className = 'kiseki-sticky-atc';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML =
      '<div class="kiseki-sticky-atc__info">' +
        '<div class="kiseki-sticky-atc__name">' + (titleEl ? titleEl.textContent.trim().substring(0, 24) : '') + '</div>' +
        '<div class="kiseki-sticky-atc__price">' + (priceEl ? priceEl.textContent.trim() : '') + '</div>' +
      '</div>' +
      '<button class="kiseki-sticky-atc__btn" type="button">' + (mainATC.textContent.trim() || 'Add to cart') + '</button>';
    document.body.appendChild(bar);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { bar.classList.toggle('is-visible', !e.isIntersecting); });
      }, { threshold: 0, rootMargin: '0px 0px -60px 0px' }).observe(mainATC);
    }
    bar.querySelector('.kiseki-sticky-atc__btn').addEventListener('click', function () { mainATC.click(); });
    var mo = new MutationObserver(function () {
      bar.querySelector('.kiseki-sticky-atc__btn').disabled = mainATC.disabled;
    });
    mo.observe(mainATC, { attributes: true, attributeFilter: ['disabled'] });
  }

  function initReadMore() {
    if (!MOBILE()) return;
    var desc = document.querySelector('.product__description');
    if (!desc || desc.scrollHeight <= 310) return;
    desc.classList.add('kiseki-collapsed');
    var btn = document.createElement('button');
    btn.className = 'kiseki-read-more';
    btn.textContent = 'Read full description ↓';
    desc.insertAdjacentElement('afterend', btn);
    btn.addEventListener('click', function () {
      var isCol = desc.classList.toggle('kiseki-collapsed');
      btn.textContent = isCol ? 'Read full description ↓' : 'Show less ↑';
      if (!isCol) desc.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });
  }

  function initTrustNote() {
    if (!document.querySelector('.product-form__submit')) return;
    if (document.querySelector('.kiseki-payment-trust')) return;
    var anchor = document.querySelector('.product-form__buttons, .product-form__submit');
    if (!anchor) return;
    var note = document.createElement('div');
    note.className = 'kiseki-payment-trust';
    note.innerHTML =
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>' +
      '<div><strong>Secure bank transfer payment</strong>' +
      'Complete checkout → receive bank details by email → transfer &amp; send receipt via WhatsApp. ' +
      'Dispatched 1–2 business days after confirmation.</div>';
    anchor.insertAdjacentElement('afterend', note);
  }

  function init() { initStickyATC(); initReadMore(); initTrustNote(); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
